import React, { useState } from 'react';
import { Pressable, Text, StyleSheet } from 'react-native';
import { Citation } from '../../services/chatApi';
import { useTheme } from '../../contexts/ThemeContext';
import { CitationModal } from './CitationModal';

export function CitationChip({ citation }: { citation: Citation }) {
  const { theme } = useTheme();
  const [open, setOpen] = useState(false);

  return (
    <>
      <Pressable
        onPress={() => setOpen(true)}
        style={[
          styles.chip,
          { borderColor: theme.colors.border, backgroundColor: theme.colors.surface },
        ]}
      >
        <Text style={{ color: theme.colors.primary, fontSize: theme.typography.fontSizeSm }}>
          {citation.label}
        </Text>
      </Pressable>
      <CitationModal visible={open} onClose={() => setOpen(false)} citation={citation} />
    </>
  );
}

const styles = StyleSheet.create({
  chip: {
    paddingHorizontal: 8,
    paddingVertical: 4,
    borderRadius: 12,
    borderWidth: 1,
    marginRight: 6,
  },
});
